// extracted by mini-css-extract-plugin
module.exports = {"stateSvg":"StateLoadingIndicator_stateSvg__e81Ld","loading":"StateLoadingIndicator_loading__hwGdE"};